export default __webpack_public_path__ + "static/media/Icon54.df074937.svg";